import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../theme";

function PrivacyPolicy() {
    const { colors } = useContext(ThemeContext)!;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <div className={`min-h-screen ${colors.bgSecondaryColor}`}>
            <div className="container mx-auto px-6 py-4 md:py-20 max-w-5xl">
                <div
                    className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                        }`}
                >
                    <h1 className={`text-4xl md:text-5xl font-black ${colors.textColor} mb-6`}>
                        Privacy Policy
                    </h1>

                    <p className={`${colors.textColor} opacity-70 mb-10`}>
                        Last updated: {new Date().toLocaleDateString()}
                    </p>

                    <section className="space-y-8 text-lg leading-relaxed">
                        {/* 1 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                1. Introduction
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                This Privacy Policy explains how I Call On (“we”, “our”, or “us”)
                                collects, uses, stores, and protects your personal information
                                when you use our mobile application, website, and related services
                                (collectively, the “Service”).
                            </p>
                        </div>

                        {/* 2 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                2. Information We Collect
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We collect information in the following ways:
                            </p>
                            <ul className={`${colors.textColor} opacity-80 list-disc list-inside mt-2 space-y-2`}>
                                <li>
                                    <strong>Account Information:</strong> such as username, display name,
                                    email address, or authentication identifiers.
                                </li>
                                <li>
                                    <strong>Gameplay Data:</strong> including game participation, scores,
                                    answers submitted during rounds, and match history.
                                </li>
                                <li>
                                    <strong>Device & Usage Data:</strong> device type, operating system,
                                    app version, crash logs, and basic analytics.
                                </li>
                                <li>
                                    <strong>Communications:</strong> messages you send to support or feedback
                                    you provide voluntarily.
                                </li>
                            </ul>
                        </div>

                        {/* 3 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                3. How We Use Your Information
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We use your information to:
                            </p>
                            <ul className={`${colors.textColor} opacity-80 list-disc list-inside mt-2 space-y-2`}>
                                <li>Provide and operate the Service</li>
                                <li>Enable multiplayer gameplay and scoring</li>
                                <li>Improve performance, stability, and user experience</li>
                                <li>Detect abuse, cheating, or violations of our Terms</li>
                                <li>Respond to user support requests</li>
                            </ul>
                        </div>

                        {/* 4 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                4. Legal Basis for Processing (GDPR)
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                If you are located in the European Economic Area (EEA), we process
                                personal data based on one or more of the following legal grounds:
                                your consent, performance of a contract, compliance with legal
                                obligations, or our legitimate interests in operating and improving
                                the Service.
                            </p>
                        </div>

                        {/* 5 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                5. Data Sharing and Third Parties
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We do not sell your personal data. We may share limited information
                                with trusted third-party service providers solely to operate the
                                Service, such as:
                            </p>
                            <ul className={`${colors.textColor} opacity-80 list-disc list-inside mt-2 space-y-2`}>
                                <li>Authentication providers</li>
                                <li>Cloud hosting and database services</li>
                                <li>Analytics and crash reporting tools</li>
                            </ul>
                        </div>

                        {/* 6 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                6. Data Retention
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We retain personal data only for as long as necessary to provide
                                the Service, comply with legal obligations, resolve disputes, and
                                enforce our agreements. You may request deletion of your data at
                                any time.
                            </p>
                        </div>

                        {/* 7 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                7. Data Security
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We implement reasonable technical and organizational measures to
                                protect your information against unauthorized access, loss, misuse,
                                or alteration. However, no system is completely secure.
                            </p>
                        </div>

                        {/* 8 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                8. Children’s Privacy
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                I Call On is not intended for children under the age of 13. We do
                                not knowingly collect personal information from children. If you
                                believe a child has provided us with data, please contact us.
                            </p>
                        </div>

                        {/* 9 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                9. Your Rights
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                Depending on your location, you may have the right to access,
                                correct, delete, or restrict the use of your personal data. You
                                may also object to processing or request data portability.
                            </p>
                        </div>

                        {/* 10 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                10. International Data Transfers
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                Your data may be processed and stored on servers located outside
                                your country. We ensure appropriate safeguards are in place in
                                accordance with applicable data protection laws.
                            </p>
                        </div>

                        {/* 11 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                11. Changes to This Policy
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                We may update this Privacy Policy from time to time. Any changes
                                will be posted on this page, and continued use of the Service
                                indicates acceptance of the updated policy.
                            </p>
                        </div>

                        {/* 12 */}
                        <div>
                            <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                                12. Contact Us
                            </h2>
                            <p className={`${colors.textColor} opacity-80`}>
                                If you have questions or concerns about this Privacy Policy or how
                                your data is handled, please contact us through the official I Call
                                On support channels.
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
